import React from 'react';
import { useNavigate } from 'react-router-dom';
import Wordmark from '../common/Wordmark';

const WelcomeScreen = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{
        background: `
          radial-gradient(ellipse at 20% 50%, var(--gradient-warm-1) 0%, transparent 50%),
          radial-gradient(ellipse at 80% 20%, var(--gradient-warm-2) 0%, transparent 40%),
          radial-gradient(ellipse at 50% 80%, var(--gradient-warm-3) 0%, transparent 45%),
          radial-gradient(ellipse at 70% 60%, var(--gradient-warm-4) 0%, transparent 50%),
          var(--gradient-base)
        `,
        backgroundSize: '200% 200%',
        animation: 'splashGradientShift 12s ease infinite',
      }}
    >
      <div className="splash-entrance w-full max-w-sm text-center">
        {/* Mark + wordmark (brand kit 2026-09-30) — no glass card: the mark
            carries the screen on the forest ground. */}
        <img src="/brand/mark-ring.svg" alt="" className="w-44 h-44 mx-auto mb-6" />

        <h1 className="text-4xl text-white mb-2.5">
          <Wordmark />
        </h1>
        <p
          className="text-[13px] font-bold uppercase mb-1.5"
          style={{ letterSpacing: '0.14em', color: 'var(--brand-secondary)' }}
        >
          Real DSPs. Real conversations.
        </p>
        <p className="text-[15px] leading-relaxed mb-10 mx-auto max-w-[280px]" style={{ color: 'rgba(255, 255, 255, 0.78)' }}>
          A community built for Direct Support Professionals
        </p>

        {/* Join button — white on forest reads as the one primary action. */}
        <button
          onClick={() => navigate('/onboarding')}
          className="w-full py-3.5 rounded-2xl font-semibold text-base mb-3 transition-all duration-200 hover:brightness-95 active:scale-[0.98]"
          style={{ backgroundColor: '#FFFFFF', color: 'var(--gradient-base)' }}
        >
          Join DSP Cafe
        </button>

        {/* Sign In button */}
        <button
          onClick={() => navigate('/login')}
          className="w-full py-3.5 rounded-2xl font-semibold text-base text-white transition-all duration-200 hover:bg-white/10 active:scale-[0.98]"
          style={{
            border: '1.5px solid rgba(var(--brand-secondary-rgb), 0.7)',
            backgroundColor: 'transparent',
          }}
        >
          Sign In
        </button>

        {/* Sign-up is open (064): no "Invite only" line. */}
        <p className="text-center text-xs mt-7" style={{ color: 'rgba(255,255,255,0.6)' }}>
          <a href="https://dsp.cafe/terms.html" className="underline hover:opacity-80 transition-opacity">Terms of Use</a>
          {' · '}
          <a href="https://dsp.cafe/privacy.html" className="underline hover:opacity-80 transition-opacity">Privacy Policy</a>
        </p>
      </div>
    </div>
  );
};

export default WelcomeScreen;
